import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const StepCard = styled(Box)({
  border: `1px solid ${colors.border.light}`,
  borderRadius: "12px",
  padding: "24px",
  marginBottom: "16px",
  backgroundColor: "#FFFFFF",
});

export const StepHeader = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  marginBottom: "32px",
});

export const StepNumber = styled(Box)({
  width: "60px",
  height: "60px",
  borderRadius: "12px",
  backgroundColor: colors.background.darkBlue,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  color: "#FFFFFF",
  fontSize: "18px",
  fontWeight: 700,
  fontFamily: "Sora",
  flexShrink: 0,
});

export const StepContent = styled(Box)({
  flex: 1,
});

export const StepTitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.link,
  fontFamily: "Sora",
  marginBottom: "8px",
});

export const StepDescription = styled(Typography)({
  fontSize: "16px",
  color: colors.text.primary,
  fontFamily: "Nunito",
  marginBottom: "24px",
});

export const StepDetails = styled(Box)({
  display: "flex",
  gap: "80px",
});

export const StepDetailItem = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

export const StepDetailLabel = styled(Typography)({
  fontSize: "14px",
  color: colors.text.secondary,
  fontFamily: "Nunito",
});

export const StepDetailValue = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.primary,
  fontFamily: "Sora",
});

export const StepDetailHint = styled("span")({
  fontSize: "14px",
  fontWeight: 400,
  color: colors.text.primary,
  fontFamily: "Nunito",
  lineHeight: "22px",
});
